module.exports = [
    {
        id: 'v',
        answers: [
            { value: -.75, name: 'Leikkaukset', },
            { value: .75, name: 'Verot', },
        ],
    },
    {
        id: 'pt',
        answers: [
            { value: -.75, name: 'Ei', },
            { value: .75, name: 'Kyllä', },
        ],
    },
    {
        id: 'y',
        answers: [
            { value: -.75, name: 'Ympäristö', },
            { value: .75, name: 'Talouskasvu', },
        ],
    },
    {
        id: 'yv',
        answers: [
            { value: -.75, name: 'Ei', },
            { value: .75, name: 'Kyllä', },
        ],
    },
    {
        id: 'eu',
        answers: [
            { value: -.75, name: 'Ei', },
            { value: .75, name: 'Kyllä', },
        ],
    },
    {
        id: 'm',
        answers: [
            { value: -.75, name: 'Ei', },
            { value: .75, name: 'Kyllä', },
        ],
    },
    {
        id: 'a',
        answers: [
            { value: -.75, name: 'Ei', },
            { value: .75, name: 'Kyllä', },
        ],
    },
]